export const testModuleChiTietMenuI18n = {
  testModuleChiTiet: 'TEST MODULE',
  testModuleChiTietPage: {
    title: 'MODULE DETAIL TEST',
    description:
      'Each module: Test UI on the live screen. Orders group also has Create data (default 5 records, editable count).',
  },
} as const
